export default "__VITE_ASSET__5c48420d__"